import { DealRegistryPageListDueDiligenceRecordsQuery, DueDiligenceRecordStatus } from '@/__generated__/graphql';
import ModalWrappedContent from '@/components/basicComponents/modal/modalWrappedContent';
import { themeVar } from '@/styles/theme';
import styled from 'styled-components';

interface StartDueDiligenceProps {
  onClose: () => void;
  isOpen: boolean;
  currentRow: DealRegistryPageListDueDiligenceRecordsQuery['listDueDiligenceRecords']['records'][number] | null;
  startDueDiligence: (
    row: DealRegistryPageListDueDiligenceRecordsQuery['listDueDiligenceRecords']['records'][number],
    status: DueDiligenceRecordStatus
  ) => void;
}

const StartDueDiligence = ({ onClose, isOpen, startDueDiligence, currentRow }: StartDueDiligenceProps) => {
  if (!currentRow) return <></>;
  return (
    <ModalWrappedContent
      isOpen={isOpen}
      onClose={onClose}
      confirmButton={{
        name: 'Confirm',
        onClick: () => startDueDiligence(currentRow, DueDiligenceRecordStatus.Active)
      }}
    >
      <ModalContainer>
        <ModalTitel>Start Due Diligence</ModalTitel>
        <ModalDescription>
          This action will start due diligence for this deal. You can find the deal on the {currentRow.activeTier.funnel.name} Tab of the Due
          Diligence Page.
        </ModalDescription>
      </ModalContainer>
    </ModalWrappedContent>
  );
};

export default StartDueDiligence;

const ModalContainer = styled.div`
  font-weight: 400;
  padding: 50px 0;
`;

const ModalTitel = styled.div`
  font-size: 33px;
  text-align: center;
  color: ${themeVar('font.strong')};
`;

const ModalDescription = styled.div`
  font-size: 19px;
  line-height: 27px;
  text-align: center;
  color: ${themeVar('font.base')};
`;
